
export const NotificationVideoEvent= [
    'People', 'Vehicle', 'Animal','Package', 'Motion'
]

export const NotificationAudioEvent =[ 'GlassBreak', 'Smoke Alarm', 'Car Alarm']

export const  ThermostatsEvents=['Air Filter Remainder', 'Air Filter 2 Remainder', 
    'High Humidity Detected',
    'High Temperature Detected', 
    'Low Temperature',
    'Low Humidity',
 ]